import React from 'react'

export const Barras = () => {
  return (
    <span className="material-symbols-outlined">
        menu
    </span>
  )
}
